"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStyles = void 0;

require("core-js/modules/es.object.define-property.js");

var _theme = require("../theme/theme.utils");

var _utils = require("../utils");

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var useStyles = (0, _utils.createStylesHook)()(function (theme) {
  var _nthChildN;

  return {
    root: _defineProperty({
      display: 'flex',
      flexWrap: 'nowrap',
      '& > :nth-child(n)': (_nthChildN = {
        borderLeftWidth: function borderLeftWidth(props) {
          return props.elevation > 0 ? '0' : '1';
        },
        boxShadow: 'none'
      }, _defineProperty(_nthChildN, _theme.overrideClasses.before, {
        content: '""',
        position: 'absolute',
        top: '0',
        bottom: '0',
        left: '0',
        right: '0',
        zIndex: -1,
        boxShadow: function boxShadow(props) {
          return theme.shadows[props.elevation];
        }
      }), _defineProperty(_nthChildN, _theme.overrideClasses.selected, _defineProperty({}, _theme.overrideClasses.before, {
        boxShadow: 'none'
      })), _nthChildN),
      '& > :first-child, & > :first-child:before': {
        borderTopLeftRadius: 4,
        borderBottomLeftRadius: 4
      },
      '& > :last-child, & > :last-child:before': {
        borderTopRightRadius: 4,
        borderBottomRightRadius: 4,
        borderRightWidth: function borderRightWidth(props) {
          return props.elevation > 0 ? '0' : '1';
        }
      }
    }, _theme.overrideClasses.disabled, {
      '& > :nth-child(n):before ': {
        boxShadow: 'none'
      }
    }),
    rounded: {
      '& > :first-child, & > :first-child:before': {
        borderTopLeftRadius: 27,
        borderBottomLeftRadius: 27
      },
      '& > :last-child, & > :last-child:before': {
        borderTopRightRadius: 27,
        borderBottomRightRadius: 27,
        borderRightWidth: function borderRightWidth(props) {
          return props.elevation > 0 ? '0' : '1';
        }
      }
    },
    selected: {},
    disabled: {}
  };
});
exports.useStyles = useStyles;